import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './TaskResponseHeader.scss';
import {CardHeader} from 'reactstrap';
import {connect} from "react-redux";

class TaskResponseHeader extends Component {
  constructor(props) {
    super(props);
  }

  get countWaitingAckTasks() {
    return this.props.task.taskResponses
      .filter(task => !task.acknowledgedAt && task.status === 'submitted').length
  }

  get countCompletedTasks() {
    return this.props.task.taskResponses
      .filter(task => task.status === 'completed' && !task.substandard).length

  }

  get countSubstandardTasks() {
    return this.props.task.taskResponses
      .filter(task => task.substandard).length

  }

  get countRejectedTasks() {
    return this.props.task.taskResponses
      .filter(task => task.status === 'rejected').length
  }

  taskCardClick(task) {
    if (task.toggleAccordion) {
      task.toggleAccordion = !task.toggleAccordion;
    } else {
      task.toggleAccordion = true;
    }

    this.setState({
      task: task
    });
  }

  isTaskOpened(task) {
    let className = 'fa-angle-down';

    if (task.toggleAccordion) {
      className = 'fa-angle-up';
    }

    return className;
  }

  render() {
    return (
      <CardHeader onClick={() => this.props.onTaskResponseHeaderClick(this.props.task)}
                  data-event={this.props.task.taskGuid}>
        <div className="title-container">
          <div className="prompt">
            {this.props.task.prompt}
            <div className={this.countCompletedTasks >= this.props.task.min_responses ? "badge badge-success": "badge badge-danger"}>{this.countCompletedTasks}/{this.props.task.min_responses}</div>
          </div>

          {this.countWaitingAckTasks > 0 &&
          <div className="waiting-ack">
            <div>
              <b>Waiting ack.</b>
              <div className="badge badge-danger">
                {this.countWaitingAckTasks}
              </div>
            </div>
          </div>
          }

          {this.countSubstandardTasks > 0 &&
          <div className="substandard">
            <div>
              <b>Substandard </b>
              <div className="badge badge-danger">
                {this.countSubstandardTasks}
              </div>
            </div>
          </div>
          }
          {this.countRejectedTasks > 0 &&
          <div className="substandard">
            <div>
              <b>Rejected </b>
              <div className="badge badge-danger">
                {this.countRejectedTasks}
              </div>
            </div>
          </div>
          }

          <div className="completed-sign">


            {(this.props.task.taskResponses.length > 0 || this.props.canAddOrEdit) &&
            <div className={classNames('collapsed-sign fa fa-2x', this.isTaskOpened(this.props.task))}></div>
            }
          </div>
        </div>
      </CardHeader>
    );
  }
}

TaskResponseHeader.propTypes = {
  task: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {}
};

export default connect(mapStateToProps)(TaskResponseHeader);
